// extracted by mini-css-extract-plugin
export default {"tab-wrap":"tab_tab-wrap__koPvo","tab-underline":"tab_tab-underline__badte","tab-item":"tab_tab-item__55xCZ","tab-active":"tab_tab-active__bGxhu","tab-line":"tab_tab-line__G7ZIl"};